// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionPreview_root__17cAm","slideTitle":"QuestionPreview_slideTitle__2wX3F"};